// removed by extract-text-webpack-plugin
module.exports = {"button-bar":"yQZei-T6v4aZMnIYyJwcE","button-cancel":"_1dKfIULk_VgdF9W7nJv_s","button-save":"_3QvvDOKvZqttBhajmLxpqV"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressBook/components/AddressBookEdit/style.scss
// module id = 923
// module chunks = 0